t = require('app/scripts/views/internal/teacup-with-helpers')()

module.exports = t.renderable ->
  t.div '.product-promo-disable-overlay'
